module.exports = __webpack_public_path__ + "img/yellow.7522447e.png";